"use client";

import { useState } from "react";
import { Button } from "../ui/button";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

export default function CopyLinkArticle({ labels }) {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (err) {
            console.error("Erreur lors de la copie :", err);
        }
    };

    return (
        <div className="bg-gradient-to-br from-[#0f0a1f] to-[#1a1230] p-5 sm:p-6 rounded-2xl shadow-lg">
            <div className="flex items-center gap-2 mb-3">
                <SolarIcon name="share-linear" className="w-4 h-4 text-primary" />
                <h3 className="text-lg sm:text-xl text-white font-bold font-sourceSans">
                    {labels.title}
                </h3>
            </div>
            <p className="text-sm text-white/70 leading-relaxed mb-4">
                {labels.description}
            </p>
            <Button
                className="w-full group"
                onClick={handleCopy}
            >
                {isCopied ? (
                    <span className="flex items-center justify-center gap-2">
                        <SolarIcon name="unread-linear" className="w-4 h-4" />
                        {labels.copied}
                    </span>
                ) : (
                    <span className="flex items-center justify-center gap-2">
                        <SolarIcon name="link-round-linear" className="w-4 h-4 transition-transform group-hover:rotate-12" />
                        {labels.button}
                    </span>
                )}
            </Button>
        </div>
    );
}
